module.exports = __webpack_public_path__ + "media/images/pic/workshops/czesc-czesio-cbd9041fdce357c3149e87aa8761c114.jpeg";